import { Transport, LogMessage } from '../types.js';

type Valueof<T> = T[keyof T];
type ConsoleMethods = Pick<
  Console,
  'log' | 'info' | 'warn' | 'error' | 'debug'
>;

/**
 * get console transport handler
 * @returns console transport handler
 */
export const Console = (): Transport => ({
  log: async (msg: LogMessage) => {
    let level = msg.level.toLowerCase();
    if (level === 'audit') {
      level = 'info';
    } else if (level === 'fatal') {
      level = 'error';
    }
    const browserConsole = console;
    const consoleMethod = browserConsole[
      level as keyof Console
    ] as Valueof<ConsoleMethods>;
    if (consoleMethod)
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      consoleMethod(msg);
    return Promise.resolve();
  },
});
